import * as _ from 'underscore';
import { View } from './view';
import { ViewOptions } from '../../interfaces/options';
import { DefaultSectionViewOptions } from '../../const/defaultOptions';

export abstract class SectionView<T extends { id: string }> extends View {
	abstract new(...params: any[]): void;
	abstract list(): void;
	constructor(options: ViewOptions) {
		_.defaults(options, DefaultSectionViewOptions);
		super(options);
	}
	public edit(item: T) {
		window.router.navigateToRoute([this.getPath(), item.id]);
	}
}
